import useAuthenticatedAxios from "./use-authenticated-axios";
import useSWRImmutable from "swr/immutable";

export default function useTotpSecret() {
  const axios = useAuthenticatedAxios();
  const {
    data: totpSecret,
    error,
    isLoading,
  } = useSWRImmutable("/account/totp/secret", (url) =>
    axios.post(url).then((res) => res.data),
  );

  return { totpSecret, isLoading, error };
}
